
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-20 pb-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            プライバシーポリシー
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            財恩工房（以下「当事業者」）は、ボラタスサービスにおける個人情報の取り扱いについて、以下のとおり定めます。
          </p>
          <div className="w-24 h-1 bg-teal-500 mx-auto"></div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-lg max-w-none">
            
            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">1. 個人情報の収集について</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                当事業者は、以下の目的で個人情報を収集いたします：
              </p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>ボラタスサービスの提供・運営</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>利用者間のマッチング</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>謝金の支払い処理</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>お問い合わせ対応</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">2. 収集する個人情報の項目</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                当事業者が収集する個人情報は以下のとおりです：
              </p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>氏名、メールアドレス、電話番号</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>所属機関・学校名</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>活動履歴・報告内容</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>謝金支払いに関する情報</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">3. 個人情報の利用目的</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                収集した個人情報は、以下の目的で利用いたします：
              </p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>サービスの提供・改善</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>利用者サポート</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>安全性の確保</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></span>
                  <span>法的義務の履行</span>
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">4. 個人情報の第三者提供</h2>
              <p className="text-gray-700 leading-relaxed">
                当事業者は、法令に基づく場合を除き、ご本人の同意なく個人情報を第三者に提供することはありません。
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">5. 個人情報の管理</h2>
              <p className="text-gray-700 leading-relaxed">
                当事業者は、個人情報の漏洩、滅失、毀損を防止するため、適切な安全管理措置を講じます。
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">6. 個人情報の開示・訂正・削除</h2>
              <p className="text-gray-700 leading-relaxed">
                ご本人から個人情報の開示、訂正、削除の請求があった場合、適切に対応いたします。
                お問い合わせは下記連絡先までご連絡ください。
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">7. お問い合わせ窓口</h2>
              <div className="text-gray-700 leading-relaxed">
                <p className="mb-2">財恩工房</p>
                <p className="mb-2">メール：[代表メール]</p>
                <p>個人情報保護に関するお問い合わせは上記までご連絡ください。</p>
              </div>
            </div>

            <div className="bg-teal-50 border border-teal-200 rounded-2xl p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">8. プライバシーポリシーの変更</h2>
              <p className="text-gray-700 leading-relaxed">
                当事業者は、必要に応じて本プライバシーポリシーを変更することがあります。
                変更した場合は、ウェブサイト上で公表いたします。
              </p>
              <p className="text-gray-600 mt-4 text-sm">
                制定日：2024年1月1日<br />
                最終更新日：2024年1月1日
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
